export default {
  retiredWarnings: {
    summary: 'Zasób nadrzędny jest wycofany z eksploatacji',
    details: 'Zasób nadrzędny jest wycofany z eksploatacji. Ten zasób zostanie automatycznie wycofany z eksploatacji również po zapisaniu.',
  },
};
